import classNames from "classnames/bind";
import styles from "./About.module.scss";
import { dataPodcast2 } from "../../../utils/constants/data";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchPodcast } from "../../../redux/slice/podcastSlice";
import { useEffect } from "react";
import { Card } from "antd";
const cx = classNames.bind(styles);
function About() {
  const { result } = useAppSelector((state) => state.podcast);
  const dispatch = useAppDispatch();
  let query = `current=1&pageSize=9&sort=-createdAt`;
  const handleFetchPodcast = () => {
    dispatch(fetchPodcast({ query }));
  };
  useEffect(() => {
    handleFetchPodcast();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  return (
    <div className={cx("wrapper")}>
      <div className={cx("wrapper-about")}>
        <h3 className={cx("title-about")}>Lời giới thiệu</h3>
        <div className={cx("row-about")}>
          <div className={cx("content-left")}>
            <iframe
              src="https://www.youtube.com/embed/RdezgkJJjak"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen></iframe>
          </div>
          <p className={cx("content-right")}>
            ✔ Việt Anh Blogger được xây dựng với phương châm: "Chia sẻ không
            giới hạn". Là blog cộng đồng - mong muốn chia sẻ những hiểu biết,
            kiến thức về cuộc sống, sức khỏe, công việc, học tập, tài liệu được
            chia sẻ đến tất cả mọi người hoàn toàn miễn phí.
          </p>
        </div>
      </div>
      <div className={cx("container")}>
        <h3 className={cx("title-podcast")}>Các video yêu thích</h3>
        <div className={cx("container-podcast")}>
          {result?.length > 0 ? (
            result.map((item: any, index: any) => {
              return (
                <a
                  key={index}
                  href={item.urlPodcast}
                  target="_blank"
                  className={cx("item-podcast")}
                  rel="noreferrer">
                  <img src={item.image} alt="avatar" />
                </a>
              );
            })
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Card loading={true}></Card>
              <Card loading={true}></Card>
              <Card loading={true}></Card>
            </div>
          )}
        </div>
        <div className={cx("btn-podcast")}>
          <button>Xem tất cả các phát hành</button>
        </div>
      </div>
      <div className={cx("chanel_podcast")}>
        <h3 className={cx("title-chanel-podcast")}>
          CÁC KÊNH TÔI TỰ HỌC TRỰC TUYẾN
        </h3>
        <p className={cx("section-text-chanel")}>
          Các bạn nên chọn các kênh tự học hiệu quả với bản thân mình để phát
          triển bản thân.
        </p>
        <div className={cx("container-chanel-podcast")}>
          {dataPodcast2.map((item, index) => {
            return (
              <a
                key={index}
                href={item.urlPodcast}
                target="_blank"
                className={cx("item-chanel")}
                rel="noreferrer">
                <img src={item.image} alt="avatar" />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default About;
